namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DialogAdmVlastnostDefaultValue extends GContentBase {
        data: Gordic.AdmIsl.Interface.GAdmVlastnostSaveDto;
        private formArea: JQuery<HTMLElement>;

        prepareContent() {
            this.createActions();
            this.createForm();
            this.createCommandBar();
        }

        private createActions() {
            this.actions.addRange({
                actSaveDefaultValue: {
                    caption: "jres:33000243",
                    run: (ev, ctx) => {
                        this.saveDefaultValue();
                    }
                },
                actCancelDialog: {
                    caption: "jres:32131042",
                    run: (ev, ctx) => {
                        this.close();
                    }
                }
            })
        }

        private createForm() {
            this.formArea = $.newDiv().appendTo(this.element)
            if (this.data.typ_vla != 40) {
                var vlastnostiBuilder = new Gordic.Gin.WebClient.GVlastnostiBuilder(
                    this.formArea,
                    undefined,
                    undefined,
                    undefined,
                    {
                        Ixp: "",
                        DuvodHledani: Gordic.Gin.Globals.Enums.DuvodHledaniEsu.zadaniVlastnostiDokumentu,
                        DuvodHledaniTxt: "jres:33000476".format(this.data.nazev?.toString()) //RC 33000476 : Zadání výchozí hodnoty vlastnosti {0} v administraci
                    }
                )
                vlastnostiBuilder.addProfilToElement({
                    ixs_pro: this.data.ixs_vla,
                    nazev: this.data.nazev,
                    samostatnaVlastnost: true,
                    kod: this.data.kod,
                    Struktury: [{
                        ixs_stv: this.data.ixs_vla,
                        nazev: this.data.nazev,
                        kod: this.data.kod,
                        aktivita: 100,
                        Vlastnosti: [this.data]
                    }],
                })
                this.formArea.findFields().gfield("model", "apply", {
                    ixx: undefined,
                    vla_data: [
                        {
                            hovla: this.data.hovla,
                            hovla_txt: this.data.hovla_txt,
                            ixs_pro: this.data.ixs_vla,
                            ixs_stv: this.data.ixs_vla,
                            ixs_vla: this.data.ixs_vla,
                        }
                    ]
                });
            } else {
                var form = new Gordic.Forms.Form({ layoutDescriptor: "L1M1S1" }).addRow("jres:29802534").addField("gselectbox", Gordic.Esu.Prefabs.vyberEsu({
                    typ: Gordic.Esu.Globals.Enums.TypZobrazeniKaroteka.SelectEsu,
                    Logovani: {
                        Ixp: "000000000000",
                        DuvodHledani: Gordic.Gin.Globals.Enums.DuvodHledaniEsu.zadaniVlastnostiDokumentu,
                        AktZnacka: "",
                        DuvodHledaniTxt: "jres:33000476".format(this.data.nazev?.toString()) //RC 33000476 : Zadání výchozí hodnoty vlastnosti {0} v administraci
                    }
                }), {
                    name: "hovla",
                    initialValue: { ixs_esu: this.data.hovla }
                })
                $("<div>").appendTo(this.formArea).gform("createFrom", form);
            }
        }

        private saveDefaultValue() {
            var defaultValue = this.getDefaultValue();
            this.data.NewRecord = false;
            this.data.hovla = defaultValue.hovla;
            this.data.hovla_txt = defaultValue.hovla_txt;
            (this.isl.AdmVlastnost.upsert({ data: this.data }).get() as any).done((output) => {
                this.notification("showToast", {
                    title: "jres:33000475",
                    content: "jres:33000175",
                    state: "success",
                    icon: "fa-check-circle"
                })
                this.close(true);
            }).fail(() => {
                this.showFlash({
                    state: "error",
                    id: "error-default-value",
                    content: "jres:33000174"
                })
            })
        }

        private getDefaultValue(): { hovla: string | null, hovla_txt: string | null } {
            if (this.data.typ_vla != 40) {
                var formData: any = {};
                this.formArea.findFields().gfield("model", "collect", formData);
                if (formData) {
                    if (formData.vla_data) { 
                        if (formData.vla_data.length > 0) {
                            return { hovla: formData.vla_data[0].hovla, hovla_txt: formData.vla_data[0].hovla_txt }
                        }
                    }
                }
            } else {
                var value = this.findFields("hovla").gfield("getValue")
                if (value) {
                    if (!Array.isArray(value)) {
                        return { hovla: value.ixs_esu, hovla_txt: value.esu_txt }
                    }
                }
            }
            return { hovla: null, hovla_txt: null }
        }

        private createCommandBar() {
            this.commandBar(this.actions.createBar([
                {
                    action: this.actions.actSaveDefaultValue,
                    primary: true
                }, 
                {
                    action: this.actions.actCancelDialog
                }
            ]))
        }
    }
}